// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pqp1","textarea":"styles_textarea__1gjO_"};